import React, { useCallback, useState } from "react";
import { CONTACT_EMAIL } from "@/lib/contact";
import { cn } from "@/lib/utils";

export const CopyEmail = ({
  className = "",
  children,
  copiedLabel = "Copied!",
  "data-testid": testId,
}) => {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = CONTACT_EMAIL;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  }, []);

  const label = children ?? CONTACT_EMAIL;

  return (
    <button
      type="button"
      onClick={copy}
      data-testid={testId}
      className={cn("border-0 font-inherit", className)}
      aria-label={
        copied ? "Email copied to clipboard" : `Copy ${CONTACT_EMAIL} to clipboard`
      }
    >
      {copied ? copiedLabel : label}
    </button>
  );
};

export default CopyEmail;
